import React from "react";
import { traducirPagina } from "../../librerias/funciones";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";


const CPSearch = ({ textoBuscador = "", onChangeInput = () => { }, onCloseInput = () => { }, className = "",styles={} }) => {

    return (
        
            <div className={`grid-container ${className}`} style={{ backgroundColor: '#eee', padding: '0px',...styles }}>
                <div className="grid-item" >
                    <input className="form-control eliminarFoco " type="text" aria-label="Search" placeholder={traducirPagina("Buscar")} style={{ backgroundColor: "transparent", border: '0px', height: '100%', color: '#000' }} name="txtInputCliente" autoComplete="off"
                        onChange={(e) => {
                            onChangeInput(e)
                        }}
                        value={textoBuscador} />
                </div>




                <div className="grid-item" style={{display:'flex'}} >
                    <button style={{ visibility: textoBuscador.trim() === "" ? 'hidden' : 'visible' }} className="btn-matriculav2 btnEliminarBuscador"
                        onClick={(e) => { onCloseInput(e) }}>
                        <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />
                    </button>

                    <button className="btn_buscador_tarifa">  <SearchOutlined style={{ fontSize: '20px' }} /> {traducirPagina("Buscar")} </button>
                </div>
            </div>
        
    )
}

export default CPSearch;